import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';



i18n
    .use(HttpBackend)
    .use(initReactI18next)
    .init({
        backend: {
            loadPath:  `${import.meta.env.VITE_BASE_LOCALIZE}/{{lng}}.json`
        },
        lng: 'en',
        lowerCaseLng: true,
        cleanCode: true,
        fallbackLng: 'en', // fallback language
        interpolation: {
            escapeValue: false, // React already does escaping
        },
    });


export default i18n;
